// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"812":"chatRoom","969":"sharing"}[chunkId] + "." + {"812":"416722fa","969":"de548af8"}[chunkId] + ".css";
};